import React from 'react'
import { Box, Stack, SxProps, Theme } from '@mui/material'
import { GridToolbarContainer } from '@mui/x-data-grid'
import CustomSearchbar from 'common/AbstractDataGrid/CustomSearchbar'

import { FilterProps } from './CustomDataGridFilter'
import CustomDataGridServerFiter, {
  ServerFilterProps
} from './CustomDataGridServerFilter'
import CustomServerSearchbar, {
  CustomServerSearchbarProps
} from './CustomServerSearchbar'
import CustomWinbackDataGridFilter from './CustomWinbackDataGridFilter'

export function CustomWinbackToolbar(props: ToolbarProps) {
  const {
    filterProps,
    serverFilterProps,
    buttons,
    dateRangePicker,
    searchBar,
    serverSearchBarProps,
    filter,
    menuSx
  } = props

  let showSearchBar = true
  if (searchBar === 'disabled') {
    showSearchBar = false
  }

  let searchbarComponent = <CustomSearchbar />
  if (searchBar === 'server') {
    searchbarComponent = (
      <CustomServerSearchbar
        onSubmit={serverSearchBarProps?.onSubmit}
        onChange={serverSearchBarProps?.onChange}
        options={serverSearchBarProps?.options}
        defaultValue={serverSearchBarProps?.defaultValue}
        handleChange={serverSearchBarProps?.handleChange}
      />
    )
  }

  const filterVersion =
    filter === 'server'
      ? serverFilterProps && (
          <CustomDataGridServerFiter
            filterFields={serverFilterProps.filterFields}
            filterActive={serverFilterProps.filterActive}
            setFilterActive={serverFilterProps.setFilterActive}
            menuSx={menuSx ? menuSx : undefined}
          />
        )
      : filterProps && (
          <CustomWinbackDataGridFilter
            filterFields={filterProps.filterFields}
            filterActive={filterProps.filterActive}
            setFilterActive={filterProps.setFilterActive}
            rows={filterProps.rows}
            setFilteredRows={filterProps.setFilteredRows}
            menuSx={menuSx ? menuSx : undefined}
          />
        )

  return (
    <GridToolbarContainer
      sx={{
        width: '100%',
        minHeight: '60px',
        mb: '10px'
      }}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        spacing={2}
        width='100%'
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {filterVersion}
        </Box>
        <Stack direction='row' justifyContent='space-between' spacing={'50px'}>
          {!!dateRangePicker && dateRangePicker}
          {showSearchBar && searchbarComponent}
          {!!buttons && buttons}
        </Stack>
      </Stack>
    </GridToolbarContainer>
  )
}

export interface ToolbarProps {
  filterProps?: FilterProps
  serverFilterProps?: ServerFilterProps
  dateRangePicker?: JSX.Element
  buttons?: JSX.Element
  searchBar?: string
  serverSearchBarProps?: CustomServerSearchbarProps
  filter?: string
  menuSx?: SxProps<Theme>
}
